import {
  DARK_MODE_TEXT,
  HARD_MODE_TEXT,
  HIGH_CONTRAST_MODE_TEXT,
  SETTINGS_MODAL_TITLE_TEXT,
} from '../../constants/strings'
import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
}: Props) => {
  return (
    <BaseModal
      title={SETTINGS_MODAL_TITLE_TEXT}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="grid-cols-2 gap-4">
        <SettingsToggle
          settingName={HARD_MODE_TEXT}
          flag={isHardMode}
          handleFlag={handleHardMode}
        />
        <SettingsToggle
          settingName={DARK_MODE_TEXT}
          flag={isDarkMode}
          handleFlag={handleDarkMode}
        />
        <SettingsToggle
          settingName={HIGH_CONTRAST_MODE_TEXT}
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
        />
      </div>
    </BaseModal>
  )
}
